import React, { createContext, useContext, useEffect, useState } from "react";
import {
  getAccessToken,
  getUserInfo,
  isTokenExpired,
  refreshAccessToken,
  clearTokens,
} from "./auth";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [initialized, setInitialized] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [roles, setRoles] = useState([]);

  const checkAuth = async () => {
    let token = getAccessToken();

    if (!token || isTokenExpired(token)) {
      token = await refreshAccessToken();
    }

    if (token) {
      const userInfo = getUserInfo();

      setUser(userInfo);
      setRoles(userInfo?.realm_access?.roles || []);
      setIsAuthenticated(true);
    } else {
      clearTokens();
      setUser(null);
      setRoles([]);
      setIsAuthenticated(false);
    }

    setInitialized(true);
  };

  const logout = () => {
    clearTokens();
    setUser(null);
    setRoles([]);
    setIsAuthenticated(false);
  };

  const applyLogin = () => {
    const userInfo = getUserInfo();

    setUser(userInfo);
    setRoles(userInfo?.realm_access?.roles || []);
    setIsAuthenticated(true);
  };

  useEffect(() => {
    checkAuth();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        initialized,
        isAuthenticated,
        user,
        roles,
        logout,
        applyLogin,
        checkAuth,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
